import { render, staticRenderFns } from "./QuestionWrongTrend.vue?vue&type=template&id=042c14e5&scoped=true"
import script from "./QuestionWrongTrend.vue?vue&type=script&lang=js"
export * from "./QuestionWrongTrend.vue?vue&type=script&lang=js"
import style0 from "./QuestionWrongTrend.vue?vue&type=style&index=0&id=042c14e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c14e5",
  null
  
)

export default component.exports